(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxReadonlyForm', {
		require: {
			mxFormCtrl: '?^mxForm',
		},
		bindings: {
			readOnly: '<',
		},
		template: '',
		controller: MxReadonlyFormCtrl,
		controllerAs: 'vm',
	});

	MxReadonlyFormCtrl.$inject = [];
	function MxReadonlyFormCtrl() {
		var vm = this;

		vm.$onChanges = function (changes) {
			if (vm.mxFormCtrl && changes.readOnly && typeof changes.readOnly.currentValue === 'boolean') {
				vm.mxFormCtrl.setExternalReadOnly(changes.readOnly.currentValue, 'mxReadonlyFormComponent');
			}
		};
	}
})();
